// ============================================================================
// PROPERTY TERMS ENDPOINTS
// ============================================================================
// Endpoint definitions for Property Terms module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for property terms endpoints (matches PropertyTermsController route)
 */
const BASE_PATH = '/PropertyTerms';

/**
 * Property Terms Endpoints
 */
export const propertyTermsEndpoints = {
  /**
   * Get all property terms (paginated)
   * GET /PropertyTerms
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get property terms by ID
   * GET /PropertyTerms/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Create new property terms
   * POST /PropertyTerms
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update property terms
   * PUT /PropertyTerms/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete property terms
   * DELETE /PropertyTerms/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Get current terms text for a property
   * GET /PropertyTerms/current?propertyId=X&termType=Y&languageCode=Z
   */
  current: () => buildEndpoint(`${BASE_PATH}/current`),
} as const;

/**
 * Export endpoints
 */
export default propertyTermsEndpoints;
